import React, { useEffect } from "react";
import { SnackbarProvider } from "notistack";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import store from "./store/store";
const root = createRoot(document.getElementById("root"));

const RenderApplication = () => {
  useEffect(() => {
    function adjustFontSize() {
      if (window.innerWidth >= 1440) {
        document.documentElement.style.fontSize = "1.1vw";
        document.body.style.fontSize = "1.1vw";
      } else {
        document.documentElement.style.fontSize = "";
        document.body.style.fontSize = "";
      }
    }

    adjustFontSize();
    window.addEventListener("resize", adjustFontSize);

    // Fix refresh issue by ensuring styles apply after initial render
    setTimeout(() => {
      adjustFontSize();
    }, 100);

    return () => window.removeEventListener("resize", adjustFontSize);
  }, []);

  return (
    <Provider store={store}>
      <SnackbarProvider
        maxSnack={1}
        autoHideDuration={2000}
        anchorOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
        style={{ zIndex: 99999 }}
      >
        <App />
      </SnackbarProvider>
    </Provider>
  );
};
root.render(
  <Provider store={store}>
    <RenderApplication />
  </Provider>
);

reportWebVitals();
